// Archived equipment and maintenance tasks (sql/archive.sql): archived_at set = inactive, kept with its history.
// One rule for the pages (src/lib/api.js), the AI (api/_agent.js), the daily e-mail (api/_mail.js) and Survey readiness:
// lists, counts and lookups skip archived rows; a read of ONE row by its id still finds it (history, links, Unarchive).
// Before the SQL has run the column is missing: the reader drops the filter and remembers that (app works as before).
export const ARCHIVABLE = ['equipment', 'maintenance_tasks']
export const ARCHIVE_FIELDS = { archived_at: 'Archived At', archived_by: 'Archived By', archive_reason: 'Archive Reason' }

// a PostgREST query string -> the same, active rows only (unless it reads one row by id or asks about archived_at itself)
export function activeQuery(table, query) {
  const q = String(query || '')
  if (!ARCHIVABLE.includes(table) || /(^|&)archived_at=/.test(q) || /(^|&)id=eq\./.test(q)) return q
  return q + (q ? '&' : '') + 'archived_at=is.null'
}
// the error a database without sql/archive.sql gives for the filter
export const missingArchive = text => /archived_at/.test(String(text || '')) && /42703|does not exist|PGRST|schema cache|column/i.test(String(text || ''))
export const isArchived = r => !!(r && (r.archived_at || r['Archived At']))
// "Archived 12 Oct 2026 by Ladi - replaced by EQ-112"
export function archivedLine(r) {
  const at = r && (r.archived_at || r['Archived At']), by = r && (r.archived_by || r['Archived By']), why = r && (r.archive_reason || r['Archive Reason'])
  if (!at) return ''
  const d = new Date(at)
  return 'Archived ' + (isNaN(d) ? String(at).slice(0, 10) : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })) + (by ? ' by ' + by : '') + (why ? ' - ' + why : '')
}
